import {
    getDataWithParams,
    destroyData,
    uploadData,
    downloadFile,
    postData
    

} from '@/store/api/method-mbkm'

const itemInit = {
    id: null,
    name: null,
    status: null,
    date: [],
    topic: null,
    research_description: null,
    quota: null,
    interview_date: null,
    interview_media: null,
    research_requirement: null,
    proposal_file: null,
    proposal_file_result: null,
    outcame_type: []
}

const requestInit = {
    page: 1,
    show: 10,
    sortBy: "created_at",
    sorting: "ASC",
    search: null,
    filter: null
}
const initialState = () => ({
    data: {}, //Objek
    alluniversities: [], //Array
    msg: "Jaringan Bermasalah",
    status: 0,
    request: {...requestInit},
    response: {},
    blobData: null,
    item: {...itemInit},
    researchStatus: [
        {
            class: "y-alert-warning",
            value: "Menunggu disetujui prodi",
            id: 0
        },
        {
            class: "y-alert-success",
            value: "Pendaftaran Penelitian Berhasil",
            id: 1
        },
        {
            class: "y-alert-error",
            value: "Pendaftaran Penelitian Ditolak",
            id: 91  
        },
    ],
    researchOpenStatus: [
        {
            class: "y-alert-error",
            value: "Ditutup",
            id: 0
        },
        {
            class: "y-alert-success",
            value: "Dibuka",
            id: 1
        },
    ],
})

const state = initialState

const getters = {
    getData: state => state.data || {},
    getRequest: state => state.request,
    getResponse: state => state.response,
    getMsg: state => state.msg,
    getStatus: state => state.status,
    getItem: state => state.item,
    getresearchStatus: state => (id) => state.researchStatus.find(x=>x.id==id),
    getOpenStatus: state => (isOpen) => state.researchOpenStatus.find(x=>x.id==isOpen),
    getBlobData: state => state.blobData,
    getAllStatus: state => state.researchStatus,
}

const mutations = {
    
    SET_FAILED(state) {
        state.msg = 'Jaringan Bermasalah'
        state.status = '0'
    },
    SET_MSG_FAILED(state, err) {
        if (err.status == 400) {
            state.msg = err.data.response
            state.status = err.data.status
        } else {
            state.msg = 'Jaringan Bermasalah'
            state.status = '0'
        }
    },
    SET_RESPONSE(state, response) {
        state.msg= response.msg,
        state.status= response.status
    },
    SET_DATA(state, value) {
        state.data = value
    },
    SET_REQUEST(state, value) {
        state.request = value
    },
    SET_ITEM(state, value) {
        state.item = value
    },
    resetState(state) {
        const initial = initialState()
        Object.keys(initial).forEach(key => { state[key] = initial[key] })
    },
    SET_BLOBDATA(state, {value, type}) {
        state.blobData = new Blob([value], { type: type })
    },
}


const actions = {
    setRequest({commit}, value){
        commit('SET_REQUEST',value)
    },
    setItem({commit}, value){
        commit('SET_ITEM',{...value})
    },
    resetItem({commit}){
        commit('SET_ITEM', {...itemInit})
    },
    resetRequest({commit}){
        commit('SET_REQUEST', {...requestInit})
    },

    //Region Pendaftaran Dosen dan Verifikasi
    //Get semua pendaftaran yang diajukan dosennya (API DOSEN)
    async getAllData({commit, state}) {
        try {
            const response = await getDataWithParams('/research/registration', state.request)
            commit('SET_RESPONSE', response.data)
            commit('SET_DATA', response.data.data)
        } catch (e) {
            if (e.response) {
                commit('SET_MSG_FAILED', e.response)
            } else {
                commit('SET_FAILED')
            }
        }
    },

    //Get semua pendaftaran yang diajukan dosen (API KAPRODI)
    async getAllRegistrationDosen({commit, state }) 
    {
        try {
            const response = await getDataWithParams('/research-verifyDosen', state.request)
            commit('SET_RESPONSE', response.data)
            commit('SET_DATA', response.data.data)
        } catch (e) {
            if (e.response) {
                commit('SET_MSG_FAILED', e.response)
            } else {
                commit('SET_FAILED')
            }
        }
    },

    //Get Semua Pembukaan Lowongan Penelitian (API Mahasiswa)
    async getAllOprec({commit, state }) 
    {
        try {
            const response = await getDataWithParams('/research/oprec', state.request)
            commit('SET_RESPONSE', response.data)
            commit('SET_DATA', response.data.data)
        } catch (e) {
            if (e.response) {
                commit('SET_MSG_FAILED', e.response)
            } else {
                commit('SET_FAILED')
            }
        }
    },

    async storePendaftaranDosen({commit }, data) {
        try {
            const response = await uploadData('/research', data)
            commit('SET_RESPONSE', response.data)
        } catch (e) {
            if (e.response) {
                commit('SET_MSG_FAILED', e.response)
            } else {
                commit('SET_FAILED')
            }
        }
    },

    //Delete Pendaftaran Dosen
    async destroy({commit }, id) {
        try {
            const url = `/research/${id}`
            const response = await destroyData(url)
            commit('SET_RESPONSE', response.data)
        } catch (e) {
            if (e.response) {
                commit('SET_MSG_FAILED', e.response)
            } else {
                commit('SET_FAILED')
            }
        }
    },


    //Get Semua Pendaftaran Penelitian Mahasiswa (API Dosen)
    async getAllStudentRegistration({commit, state }, role) 
    {
        try {
            if(role=='kaprodi' || role =='sekprodi')
            {
                role = 'kaprodi'
            }
            else
            {
                role = 'dosen'
            }
            const url = `/research/${role}/studentregis`
            const response = await getDataWithParams(url, state.request)
            commit('SET_RESPONSE', response.data)
            commit('SET_DATA', response.data.data)
        } catch (e) {
            if (e.response) {
                commit('SET_MSG_FAILED', e.response)
            } else {
                commit('SET_FAILED')
            }
        }
    },

    //Get Semua Pendaftaran Penelitian (API Dosen)
    async getAllStudentRegistrationProdi({commit, state }) 
    {
        try {
            const response = await getDataWithParams('/research-verifyMahasiswa/verifyProdi', state.request)
            commit('SET_RESPONSE', response.data)
            commit('SET_DATA', response.data.data)
        } catch (e) {
            if (e.response) {
                commit('SET_MSG_FAILED', e.response)
            } else {
                commit('SET_FAILED')
            }
        }
    },

    async updateRegistrationStudent({commit }, {id, data}) {
        try {
            const url = `/research/${id}`
            const response = await uploadData(url, data)
            commit('SET_RESPONSE', response.data)
        } catch (e) {
            if (e.response) {
                commit('SET_MSG_FAILED', e.response)
            } else {
                commit('SET_FAILED')
            }
        }
    },
    async downloadFile({commit }, {item, type}) 
    {
        try {
            const url = `/research-downloadfile/${item.id}`
            const payload = {
                ...item
            }
            delete payload.id
            var response = await downloadFile(url);
            commit('SET_BLOBDATA', {value: response.data,type: type});
        } catch (e) {
            if(e.response){
                commit('SET_FAILED_MESSAGE',e.response)
            }else{
                commit('SET_FAILED')
            }
        }
    },

    async verifyPendaftaranDosen({commit }, {data, role}) {
        try {
            if(role=='kaprodi' || role =='sekprodi')
            {
                role = 'kaprodi'
            }
            else
            {
                role = 'dosen'
            }
            const url = `/research-verifyDosen/${role}/verifyProdi`
            var response = await postData(url, data)
            commit('SET_RESPONSE', response.data)
        } catch (e) {
            if(e.response){
                commit('SET_FAILED_MESSAGE',e.response)
            }else{
                commit('SET_FAILED')
            }
        }
    },

    async openOprec({commit }, {id, data}) {
        try {
            const url = `/research/isOpen/${id}`
            const response = await uploadData(url, data)
            commit('SET_RESPONSE', response.data)
        } catch (e) {
            if (e.response) {
                commit('SET_MSG_FAILED', e.response)
            } else {
                commit('SET_FAILED')
            }
        }
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}